import { Role } from '../../gs-core/common';

import { SubjectType, SubjectTypes } from './SubjectType';

export type ActionType = 'VIEW' | 'ASSIGN' | 'EDIT';

export const ActionTypes = {
  VIEW: 'VIEW' as ActionType,
  ASSIGN: 'ASSIGN' as ActionType,
  EDIT: 'EDIT' as ActionType
};

export type EDocsPermission = 'VIEW_STUDENT_DOCUMENTS' | 'VIEW_POSTDOC_DOCUMENTS' | 'VIEW_PROGRAM_DOCUMENTS' |
  'ASSIGN_TO_STUDENT' | 'ASSIGN_TO_POSTDOC' | 'ASSIGN_TO_PROGRAM' |
  'EDIT_DOCUMENTS' | 'ADMIN_ACCESS';

export const EDocsPermissions = {
  VIEW_STUDENT_DOCUMENTS: 'VIEW_STUDENT_DOCUMENTS' as EDocsPermission,
  VIEW_POSTDOC_DOCUMENTS: 'VIEW_POSTDOC_DOCUMENTS' as EDocsPermission,
  VIEW_PROGRAM_DOCUMENTS: 'VIEW_PROGRAM_DOCUMENTS' as EDocsPermission,
  ASSIGN_TO_STUDENT: 'ASSIGN_TO_STUDENT' as EDocsPermission,
  ASSIGN_TO_POSTDOC: 'ASSIGN_TO_POSTDOC' as EDocsPermission,
  ASSIGN_TO_PROGRAM: 'ASSIGN_TO_PROGRAM' as EDocsPermission,
  EDIT_DOCUMENTS: 'EDIT_DOCUMENTS' as EDocsPermission,
  ADMIN_ACCESS: 'ADMIN_ACCESS' as EDocsPermission,

  all(): EDocsPermission[] {
    return Object.keys(this)
      .filter(key => typeof this[key] === 'string')
      .map(key => this[key]);
  },

  fromAction(action: ActionType, subjectType?: SubjectType): EDocsPermission[] {
    return EDocsPermissions
      .all()
      .filter(permission => permission.startsWith(action) && ( !subjectType || permission.includes(subjectType) ));
  },

  toRole(action: EDocsPermission): Role {
    if (
      !EDocsPermissions.all().includes(action) ||
      ( !action.startsWith('ASSIGN_TO_') && !action.startsWith('VIEW_') )
    ) {
      throw new Error(`Invalid action ${action}`);
    }

    const subjectType = SubjectTypes.all().find(type => action.includes(type)) as SubjectType;

    return SubjectTypes.toRole(subjectType);
  }
}
;



// WEBPACK FOOTER //
// ./src/common/models/EDocsPermission.ts